export const selector = 'dbAMatch';

/* @ngInject */
export default function MatchDirective($parse) {
    return {
        restrict: 'A',
        require: 'ngModel',

        link(scope, element, attrs, ctrl) {
            const getValue = $parse(attrs[selector]);
            const getIgnoreCase = $parse(attrs.ignoreCase);
            const getInverse = $parse(attrs.inverse);

            ctrl.$parsers.unshift((value) => {
                validate(value);
                return value;
            });

            ctrl.$formatters.unshift((value) => {
                validate(value);
                return value;
            });

            function validate(value) {
                let valid = equals(getValue(scope), value, getIgnoreCase(scope), getInverse());
                
                ctrl.$setValidity('match', valid);
                
                return valid;
            }

            function equals(value1, value2, ignoreCase, inverse) {
                if (ignoreCase) {
                    value1 = String.prototype.toLowerCase.call(value1 || '');
                    value2 = String.prototype.toLowerCase.call(value2 || '');
                }

                return inverse ? value1 === value2 : value1 !== value2;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/match/match.directive.js